<template>
  <div class="card-form">
    <PageMain
      ref="main"
      :tableData="tableData"
      :loading="loading"
      :tablePage="page"
      @reload="reload"
      @submitDel="submitDel"
      @openEditDialog="openEditDialog"
      @checkbox-change="(rows) => (checkedRows = rows)"
    >
      <PageHeader
        ref="header"
        slot="header"
        @query="getData"
        @reset="resetPage"
      >
        <b-button
          size="sm"
          class="ml-2"
          variant="outline-success"
          @click="openEditDialog({ type: 'add' })"
          v-if="allow('A')"
        >
          <b-icon-plus></b-icon-plus>
          {{ $l('INDEX.btn_add') || '新增' }}
        </b-button>

        <el-badge
          v-if="allow('D')"
          :value="checkedRowCount"
          :hidden="!checkedRowCount"
          class="del-button ml-2"
          :class="{ clearable: !!checkedRowCount }"
        >
          <b-button
            size="sm"
            variant="outline-danger"
            @click="batchDel"
            :disabled="!checkedRowCount"
          >
            {{ '批量删除' }}
            <i class="el-icon-circle-close" @click.stop="clearCheckboxRow" />
          </b-button>
        </el-badge>
      </PageHeader>
      <pagination
        size="small"
        align="right"
        slot="pager"
        :current-page="page.curPage"
        :page-size="page.pageSize"
        :page-total="page.pageTotal"
        @change="handlePaginationChange"
      />
    </PageMain>

    <EditForm
      ref="editForm"
      :title="editFormDialogOptions.title"
      :visible.sync="editFormDialogOptions.visible"
      :disabled="editFormDialogOptions.disabled"
      :isAdd="editFormDialogOptions.isAdd"
      :reportBudgetSetCustCode="editFormDialogOptions.reportBudgetSetCustCode"
      @reload="reload"
    />
  </div>
</template>
<script>
import PageHeader from './header'
import PageMain from './main.vue'
import BaseTable from '@/mixins/base-table'
import EditLoading from '@/mixins/edit-loading'
import EditForm from '../edit-form'
export default {
  mixins: [BaseTable, EditLoading],
  components: { PageHeader, PageMain, EditForm },
  data() {
    return {
      usePage: true,
      checkedRows: [],
      editFormDialogOptions: { visible: false, reportBudgetSetCustCode: '' },
    }
  },
  computed: {
    checkedRowCount() {
      return this.checkedRows?.length || 0
    },
  },
  methods: {
    getData(form) {
      this.loading = true
      this.$api
        .reportBudgetSetCustListApi({ ...form, ...this.page })
        .then((res) => {
          this.loading = false
          this.setData(res)
        })
        .catch(() => {
          this.loading = false
        })
    },
    openEditDialog({ type, data = {} }) {
      const types = {
        edit:
          this.$l('dialog_title_edit_report_budget_set_cust') ||
          '编辑预算统计客户配置',
        add:
          this.$l('dialog_title_add_report_budget_set_cust') ||
          '新增预算统计客户配置',
        detail:
          this.$l('dialog_title_detail_report_budget_set_cust') ||
          '预算统计客户配置详情',
      }
      this.editFormDialogOptions = {
        visible: true,
        title: types[type],
        reportBudgetSetCustCode: data.reportBudgetSetCustCode,
        disabled: type === 'detail',
        isAdd: type === 'add',
      }
    },
    //批量删除的操作
    batchDel() {
      if (!this.checkedRowCount) {
        this.$message({
          showClose: true,
          message: this.$l('INDEX.tips_select_data') || '请选择数据',
          type: 'warning',
        })
        return
      }
      const listCode = this.checkedRows.map((item) => {
        return item.reportBudgetSetCustCode
      })
      this.submitDel(listCode)
    },
    async submitDel(reportBudgetSetCustCodeList) {
      const confirm = await this.$confirm(
        '是否要删除该预算统计客户配置？',
        this.$l('INDEX.label_completeDesc'),
        {
          confirmButtonText: this.$l('INDEX.product_dialog_btn_confirm'),
          cancelButtonText: this.$l('INDEX.btn_cancel'),
          type: 'warning',
        }
      )
        .then(() => true)
        .catch(() => false)
      if (!confirm) return

      this.loadingOpen()
      const res = await this.$api
        .reportBudgetSetCustDelApi({ reportBudgetSetCustCodeList })
        .catch(() => null)
      this.loadingClose()
      if (!res) return
      const { status } = res
      if (status !== 200) {
        this.$message.error(this.$l('INDEX.tips_delete_no') || '删除失败！')
        return
      }
      this.clearCheckboxRow()
      this.$refs.header.query()
      this.$message({
        showClose: true,
        message: this.$l('INDEX.tips_delete_ok') || '删除成功！',
        type: 'success',
      })
    },
    clearCheckboxRow() {
      this.checkedRows = []
      this.$refs.main.clearCheckboxRows()
    },
  },
}
</script>
<style lang="scss" scoped>
.del-button {
  .el-icon-circle-close {
    display: none;
  }
}
.del-button.clearable:hover {
  .el-icon-circle-close {
    display: inline-block;
    z-index: 999;
  }
  .el-icon-circle-close:hover {
    transform: scale(1.2);
  }
}
</style>
